import {
    faFacebookSquare,
    faGithubSquare,
    faLinkedin,
} from "@fortawesome/free-brands-svg-icons";
import { faEnvelopeSquare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Link } from "react-router-dom";
import Header from "../Home/Header/Header";
import "./Blog.css";

const Blog = () => {
    return (
        <div className="container">
            <Header></Header>
            <div className="mt-3 ms-5">
                <h3 className="skills">My Blogs</h3>
                <h1 className="text-center mt-5">
                    Blog is coming soon..........
                </h1>
                <div className="blog-icon">
                    <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://www.linkedin.com/in/saurav-ghosh-6a1ab0202/"
                    >
                        <FontAwesomeIcon className="icon" icon={faLinkedin} />
                    </a>
                    <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://github.com/saurav-ghosh"
                    >
                        <FontAwesomeIcon
                            className="icon"
                            icon={faGithubSquare}
                        />
                    </a>
                    <Link to="/contact">
                        <FontAwesomeIcon
                            className="icon"
                            icon={faEnvelopeSquare}
                        />
                    </Link>
                    <FontAwesomeIcon className="icon" icon={faFacebookSquare} />
                </div>
            </div>
        </div>
    );
};

export default Blog;
